import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';

import { BrightnavLayoutComponent } from '../brightnav-layout/brightnav-layout.component';
import { ChatComponent, CopilotFacadeService } from '@brighthub/copilot';
import { BrightnavLayoutService } from '../brightnav-layout.service';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ClientSessionService, UiSession } from '@brighthub/uisession';
import { EmployeeConversationListComponent } from '@brighthub/brightnav-employee-search';
import { EmployeeListService } from '@brighthub/brightnav-employee-search';

@Component({
  selector: 'bn-employee-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BrightnavLayoutComponent,
    ChatComponent,
    EmployeeConversationListComponent
],
  templateUrl: './employee-layout.component.html',
  styleUrl: './employee-layout.component.scss',
})
export class EmployeeLayoutComponent {
  layoutService = inject(BrightnavLayoutService);
  collapsed = computed(() => this.layoutService.collapsed());
  private _route = inject(ActivatedRoute);
  private _employeeService = inject(EmployeeListService);
  private _copilotFacadeService = inject(CopilotFacadeService);
  private _clientService = inject(ClientSessionService);
  oktaId = toSignal(
    this._route.paramMap.pipe(map((params) => params.get('oktaId')))
  );
  conversationId = toSignal(
    this._route.paramMap.pipe(map(params => params.get('conversationId')))
  );


  constructor() {
    this._copilotFacadeService.hideInput.set(true);
    effect(() => {
      const activeConvo = this._employeeService.activeConversation();
      if (activeConvo) {
        this.setConversation(activeConvo);
      } else {
        this._copilotFacadeService.clearContext();
      }
    });
  }

  setConversation(uiSession: UiSession) {
    const conversationId = uiSession.conversationId;
    if (!conversationId) {
      this._copilotFacadeService.clearContext();
      return;
    }
    this._copilotFacadeService.loadAndSelectConversation(
      uiSession.subjectId,
      conversationId,
      'active',
      false,
      uiSession.subjectData.guid
    );
    this._clientService.setSelectedSubject(uiSession.subjectData);
  }
}
